module.exports = __webpack_public_path__ + "static/Intro3dDemo-b8e92a67cc92ddf8e2013dd8ac96a537.webm";